import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

export const RestrictedInvestorDescription = () => {
	const { $t } = useIntl();

	return (
		<>
			<S.Intro>
				<S.Description>{$t('domesticRinggitBorrowing.selectedLabel')}</S.Description>
				<S.DescriptionBold>
					{$t('jurisdictionRequirements.ukSelfCategorisation.restrictedInvestorTitlePage')}
				</S.DescriptionBold>
			</S.Intro>
			<S.Paragraph>{$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText1')}</S.Paragraph>
			<S.Paragraph>{$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText2')}</S.Paragraph>
			<S.Paragraph>{$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText3')}</S.Paragraph>
			<S.Paragraph>{$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText4')}</S.Paragraph>
		</>
	);
};

namespace S {
	export const Intro = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const Paragraph = styled.p`
		${({ theme }) => theme.fonts.text.text3};
	`;

	export const Description = styled.span`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const DescriptionBold = styled.span`
		${({ theme }) => theme.fonts.headings.title5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		display: block;
	`;
}
